import DashboardIcon from "@mui/icons-material/Dashboard";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import PaymentIcon from "@mui/icons-material/Payment";
import ListAltIcon from "@mui/icons-material/ListAlt";
import HeadsetMicIcon from "@mui/icons-material/HeadsetMic";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
export interface SidebarItem {
  id: string;
  title: string;
  icon: React.ReactNode;
  children: { id: string; title: string; path: string }[];
  path: string;
}

export const DataSidebar: SidebarItem[] = [
  {
    id: "main-1",
    title: "صفحه اصلی",
    icon: <DashboardIcon />,
    children: [],
    path: "/",
  },
  {
    id: "user-1",
    title: "حساب کاربری",
    icon: <PersonOutlineIcon />,
    children: [],
    path: "/profile",
  },
  {
    id: "finance-1",
    title: "امور مالی",
    icon: <PaymentIcon />,
    children: [
      { id: "finance-1-1", title: "تراکنش‌ها", path: "/wallet-reports" },
      {
        id: "finance-1-2",
        title: "کیف پول",
        path: "/wallet-reports/wallet-balance",
      },
      {
        id: "finance-1-3",
        title: "انتقال موجودی",
        path: "/wallet-reports/balance-transfer",
      },
      {
        id: "finance-1-4",
        title: "برداشت از کیف پول",
        path: "/wallet-reports/withdraw-from-wallet",
      },
      {
        id: "finance-1-5",
        title: "شارژ کیف پول",
        path: "/wallet-reports/cash-balance-recharge",
      },
      {
        id: "finance-1-6",
        title: "افزودن کارت شتابی",
        path: "/wallet-reports/add-shetab-card",
      },
    ],
    path: "/wallet-reports",
  },
  {
    id: "credits-1",
    title: "اعتبارات",
    icon: <ListAltIcon />,
    children: [
      { id: "credits-1", title: "اعتبار سنجی", path: "/credits/validation" },
      {
        id: "credits-1-2",
        title: "اعتبارات و اقساط",
        path: "/credits/credits-installments",
      },
      {
        id: "credits-1-3",
        title: "امتیازات فروشگاهی",
        path: "/credits/store-points",
      },
      {
        id: "credits-1-4",
        title: "اعتبارات فروشگاهی",
        path: "/credits/reputable-store",
      },
    ],
    path: "/credits",
  },
  {
    id: "locations-1",
    title: "مراکز پولی پی",
    icon: <LocationOnOutlinedIcon />,
    children: [
      { id: "locations-1-1", title: "گیشه", path: "/locations" },
      { id: "locations-1-2", title: "پذیرنده", path: "/locations/merchant" },
    ],
    path: "/locations",
  },
  // {
  //   id: "partners-1",
  //   title: "پذیرندگان",
  //   icon: <StoreMallDirectoryIcon />,
  //   children: [
  //     { id: "partners-1-1", title: "لیست پذیرندگان", path: "/partners/list" },
  //     { id: "partners-1-2", title: "درخواست جدید", path: "/partners/new" },
  //   ],
  //   path: "/partners",
  // },
  {
    id: "support",
    title: "پشتیبانی",
    icon: <HeadsetMicIcon />,
    children: [],
    path: "/support",
  },
  // {
  //   id: "settings-1",
  //   title: "تنظیمات",
  //   icon: <SettingsApplicationsIcon />,
  //   children: [
  //     { id: "settings-1-1", title: "تنظیمات حساب", path: "/settings/account" },
  //     { id: "settings-1-2", title: "امنیت", path: "/settings/security" },
  //   ],
  //   path: "/settings",
  // },
];
